
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news/gallabox-raises-3.5-million-to-fuel-its-mission",
      function () {
        return require("private-next-pages/news/gallabox-raises-3.5-million-to-fuel-its-mission.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/news/gallabox-raises-3.5-million-to-fuel-its-mission"])
      });
    }
  